exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".section>.v-input[data-v-7ed97d92]{flex-grow:0}", ""]);

// exports
